<template>
  <b-tab-item ref="tabItem" :label="label" :value="value" :disabled="disabled" :visible="visible">
    <template #header v-if="$slots.header">
      <div @click="onHeaderClick" class="tab-item-view-header-click-area">
        <slot name="header" />
      </div>
    </template>
    <slot name="body" />
  </b-tab-item>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'TabItemView',
  emits: ['click'],
  slotsDefinition: {
    header: {},
    body: {}
  },
  props: {
    label: {
      type: String,
      required: false
    },
    value: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: true
    },
    dataGuide: {
      type: String,
      default: undefined
    }
  },
  methods: {
    onHeaderClick() {
      if (this.disabled) {
        return;
      }

      const tabItem = this.$refs.tabItem;
      tabItem?.parent?.childClick?.(tabItem);
      this.$emit('click');
    },
    getHeaderLi() {
      const uniqueValue = this.$refs.tabItem?.uniqueValue;
      if (!uniqueValue) {
        return null;
      }
      const labelEl = document.getElementById(`${uniqueValue}-label`);
      return labelEl?.parentElement ?? null;
    }
  },
  mounted() {
    if (this.dataGuide) {
      const li = this.getHeaderLi();
      li?.setAttribute('data-guide', this.dataGuide);
    }
  },
  beforeUnmount() {
    if (this.dataGuide) {
      const li = this.getHeaderLi();
      li?.removeAttribute('data-guide');
    }
  }
};
</script>

<style>
.tab-item-view-header-click-area {
  margin: -0.5em -1em calc(-0.5em - var(--bulma-tabs-border-bottom-width, 1px));
  padding: 0.5em 1em calc(0.5em + var(--bulma-tabs-border-bottom-width, 1px));
}
</style>
